// Axios reports any request that never got a response as "Network Error".
// Cross-origin calls also end up here when the browser's CORS preflight
// rejects them, which made a blocked header look like an outage. Give
// users a message that says what probably happened.
export const NO_RESPONSE_MESSAGE =
  "The server could not be reached, or the browser blocked the request. Check your connection and try again; if it keeps happening, contact support.";

export const isNoResponseError = (error) =>
  !!error && !error.response && !!error.request && error.code !== "ERR_CANCELED";

export const describeNoResponse = (error) => {
  if (!isNoResponseError(error)) return error;
  error.originalMessage = error.message;
  error.message = NO_RESPONSE_MESSAGE;
  return error;
};
